import { ChefHat, Camera, Archive, Printer } from "lucide-react";

/**
 * Bottom Action Bar fissa per Tracciabilità Lotti.
 * - Default: 2 azioni (Prepara, Scansiona)
 * - Con selezione attiva: 2 azioni (Archivia selezionati, Stampa etichette)
 */
const LottiBottomBar = ({ onPrepara, onScansiona, selectedCount = 0, onArchivia, onStampa }) => {
  const hasSelection = selectedCount > 0;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[60] bg-white/95 backdrop-blur-md border-t border-gray-200 px-3 py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]"
      data-testid="lotti-bottom-bar"
    >
      <div className="max-w-3xl mx-auto flex items-stretch gap-2">

        {hasSelection ? (
          <>
            {/* Modalità selezione: Archivia + Stampa */}
            <button
              onClick={onArchivia}
              className="flex-1 flex flex-col items-center justify-center gap-1 py-2 rounded-xl bg-gray-100 active:scale-95 active:bg-gray-200 transition-all"
              data-testid="bottombar-archivia-selezionati"
            >
              <Archive className="h-5 w-5 text-gray-700" strokeWidth={2.2} />
              <span className="text-[11px] font-semibold text-gray-800">Archivia {selectedCount}</span>
            </button>

            <button
              onClick={onStampa}
              className="flex-[1.4] flex items-center justify-center gap-2 py-2 px-3 rounded-xl bg-amber-500 active:scale-95 active:bg-amber-600 transition-all shadow-md shadow-amber-500/20"
              data-testid="bottombar-stampa-selezionati"
            >
              <Printer className="h-5 w-5 text-black" strokeWidth={2.4} />
              <span className="text-sm font-extrabold text-black">
                Stampa {selectedCount}
              </span>
            </button>
          </>
        ) : (
          <>
          {/* Modalità default: Scansiona / Prepara */}
            <button
              onClick={onScansiona}
              className="flex-1 flex flex-col items-center justify-center gap-1 py-2 rounded-xl bg-gray-100 active:scale-95 active:bg-gray-200 transition-all"
              data-testid="bottombar-scansiona"
            >
              <Camera className="h-5 w-5 text-gray-700" strokeWidth={2.2} />
              <span className="text-[11px] font-semibold text-gray-800">Scansiona</span>
            </button>

            <button
              onClick={onPrepara}
              className="flex-[1.4] flex items-center justify-center gap-2 py-2 px-3 rounded-xl bg-amber-500 active:scale-95 active:bg-amber-600 transition-all shadow-md shadow-amber-500/20"
              data-testid="bottombar-prepara"
            >
              <ChefHat className="h-5 w-5 text-black" strokeWidth={2.4} />
              <span className="text-sm font-extrabold text-black">Prepara</span>
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default LottiBottomBar;
